import { gql } from "@apollo/client";

export const GET_ALL_FIGURA_PROFESIONAL = gql`
query allFiguraProfesional {
    allFiguraProfesional
    {
        idFiguraProfesional
        idTipoProfesional
        descripcion
    }
}`;

export const adaptFiguraProfesional = (figuraProfesional) => {
  return {
    id: figuraProfesional?.idFiguraProfesional,
    displayName: figuraProfesional?.descripcion,
    idTipoProfesional: figuraProfesional?.idTipoProfesional
  };
};

const adaptFiguraProfesionalArray = (figurasProfesional) => {

  return structuredClone(figurasProfesional?.allFiguraProfesional)?.
  map((figuraProfesional) => adaptFiguraProfesional(figuraProfesional)) || [];
};

export default adaptFiguraProfesionalArray;